import { createFileRoute } from "@tanstack/react-router";
import { ForbiddenError } from "@/lib/api-client";
import { sessionHasPermission, sessionQueryKey } from "@/queries/session";
import type { AdminSession } from "@/queries/session";
import { ProductAreaReconciliationPage } from "@/features/product-areas/pages/product-area-reconciliation-page";

export const Route = createFileRoute("/_authed/tenant-records/$slug/subscription")({
  beforeLoad: ({ context }) => {
    if (!sessionHasPermission(context.queryClient.getQueryData<AdminSession>(sessionQueryKey), "product_areas.census")) {
      throw new ForbiddenError(null, null, "Your platform role does not include product subscriptions.");
    }
  },
  component: ProductAreaReconciliationPage,
});
